import { useEffect, useRef } from 'react'

const STAR_COUNT = 160

export default function BackgroundFX() {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')

    let w, h, animId, stars = []

    function mkStar(randomY = true) {
      return {
        x:         Math.random() * window.innerWidth,
        y:         randomY ? Math.random() * window.innerHeight : window.innerHeight + 2,
        size:      Math.random() * 1.4 + 0.3,
        speed:     Math.random() * 0.12 + 0.03,
        opacity:   Math.random(),
        opTarget:  Math.random() * 0.7 + 0.15,
        opSpeed:   Math.random() * 0.008 + 0.002,
        color:     [[14,165,233],[99,102,241],[148,163,184],[56,189,248]][Math.floor(Math.random()*4)],
      }
    }

    function resize() {
      w = canvas.width  = window.innerWidth
      h = canvas.height = window.innerHeight
    }
    resize()
    window.addEventListener('resize', resize)

    stars = Array.from({ length: STAR_COUNT }, () => mkStar(true))

    function draw() {
      ctx.clearRect(0, 0, w, h)

      for (const s of stars) {
        // Drift upward very slowly
        s.y -= s.speed
        if (s.y < -2) { Object.assign(s, mkStar(false)); s.x = Math.random() * w }

        // Twinkle
        if (Math.abs(s.opacity - s.opTarget) < s.opSpeed) {
          s.opTarget = Math.random() * 0.7 + 0.15
        }
        s.opacity += (s.opTarget - s.opacity) * s.opSpeed * 8

        // Draw with soft glow
        const [r, g, b] = s.color
        const grd = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, s.size * 3)
        grd.addColorStop(0,   `rgba(${r},${g},${b},${(s.opacity).toFixed(2)})`)
        grd.addColorStop(0.4, `rgba(${r},${g},${b},${(s.opacity * 0.4).toFixed(2)})`)
        grd.addColorStop(1,   `rgba(${r},${g},${b},0)`)

        ctx.beginPath()
        ctx.arc(s.x, s.y, s.size * 3, 0, Math.PI * 2)
        ctx.fillStyle = grd
        ctx.fill()

        // Sharp center dot
        ctx.beginPath()
        ctx.arc(s.x, s.y, s.size * 0.6, 0, Math.PI * 2)
        ctx.fillStyle = `rgba(255,255,255,${(s.opacity * 0.9).toFixed(2)})`
        ctx.fill()
      }

      animId = requestAnimationFrame(draw)
    }

    animId = requestAnimationFrame(draw)

    return () => {
      cancelAnimationFrame(animId)
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 0 }}
      aria-hidden
    />
  )
}
